export default "__VITE_ASSET__Bjb2aZ7F__"